export default "__VITE_ASSET__DfMpteTd__"